export default __webpack_public_path__ + "img/leaderboard.d2c504bc.webp";